export const GET_DEPENDENTS_QUERY_KEY = ['dependents'] as const;

export const EDIT_DEPENDENT_QUERY_KEY = ['edit', 'dependents'] as const;

export const SAVE_NEW_DEPENDENT_QUERY_KEY = ['add new', 'dependents'] as const;

export const REMOVE_DEPENDENT_QUERY_KEY = ['remove', 'dependents'] as const;

export const RESTORE_DEPENDENT_QUERY_KEY = ['restore', 'dependents'] as const;
